module.exports = __webpack_public_path__ + "PatinEB00.png?3aa0aac5e41ab039670ddf1843082f3a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PatinEB00.png
// module id = 2616
// module chunks = 0